export class CandidateColor {
  constructor(data = {}) {
    this.id = data.id || null;
    this.order = data.order || '';
    this.hex_color_code = data.hex_color_code || '#000000';
  }
}